import { SvgIconType } from './svg.interface';

const ArrowRight: SvgIconType = ({ width = 9, height = 8, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.79158 3.49998L4.49593 1.20432C4.30048 1.00888 4.30048 0.692001 4.49593 0.496558C4.69137 0.301115 5.00825 0.301115 5.20369 0.496558L8.35355 3.64642C8.54882 3.84168 8.54882 4.15827 8.35355 4.35353L5.20369 7.50339C5.00825 7.69884 4.69137 7.69884 4.49593 7.50339C4.30048 7.30795 4.30048 6.99108 4.49593 6.79563L6.79158 4.49998H1C0.723858 4.49998 0.5 4.27612 0.5 3.99998C0.5 3.72383 0.723858 3.49998 1 3.49998H6.79158Z"
      fill="#6A7383"
    />
  </svg>
);

export default ArrowRight;
